import React, { createContext, useEffect, useState } from "react";
import { getAllReminders } from "../APIs/remindersApis";
import secureLocalStorage from "react-secure-storage";
import { notificationsSocket } from "../socket";

import { convertTo12HourFormat, showInfoToast } from "../utils/helpers";
import { getAllCases } from "../APIs/caseApis";

// Create the Context
export const AppContext = createContext();

// Create the Provider component
export const AppProvider = ({ children }) => {
  const [socketNotifications, setSocketNotifications] = useState();
  const [allreminders, setAllReminders] = useState([]);
  const [allCases, setAllCases] = useState([]);
  const [selectedCase, setSelectedCase] = useState(null); 
  const [newCaseAdded, setNewCaseAdded] = useState(false);

  useEffect(() => {
    const loginData = secureLocalStorage.getItem("loginCredentials");
    loginData && notificationsSocket.emit("register", loginData.user.id);

    // Listen for dataEvent emitted by the server
    notificationsSocket.on("dataEvent", (data) => {
      setSocketNotifications(data);
      console.log("Received data from server:", data);

      showInfoToast(
        ` You have a deadline for the ${
          data.data.title
        } case by ${convertTo12HourFormat(data.data.time)}`,
        5000
      );
    });
  }, []);

  useEffect(() => {
    getAllReminders()
      .then((res) => {
        // console.log(res);
        setAllReminders(res);
      })
      .catch((err) => {
        console.log(err);
      });
 
  }, []);


  useEffect(() => {
   
      getAllCases()
        .then((res) => {
          setAllCases(res);
        })
        .catch((err) => {
          console.log(err);
        });

  }, [newCaseAdded]);
  // Add any shared state or methods here
  const updateAllReminders = () => {
    getAllReminders()
      .then((res) => {
        console.log(res);
        setAllReminders(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <AppContext.Provider
      value={{
        updateAllReminders,
        allreminders,
        socketNotifications,
        setSocketNotifications,
        allCases,
        setAllCases,
        getAllCases,
        setNewCaseAdded,
        selectedCase, 
        setSelectedCase,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
